'use strict';

angular
	.module('bringgApp')
	.factory('DriverConfiguration', function ($resource, WEB_API_URL) {
		var driverConfigurationServices = $resource(
			WEB_API_URL + '/merchant/user_configuration/',
			{},
			{
				update: { method: 'PUT' }
			}
		);

		return driverConfigurationServices;
	})
	.factory(
		'DriverConfigurations',
		function (DriverConfiguration, $rootScope, Authentication, $q, CLUSTER_MODE_TYPES) {
			const INVENTORY_PICKUP_CLUSTER_MODE = 2;
			const INVENTORY_PICKUP_DROP_OFF_CLUSTER_MODE = 4;

			var service = {};
			var driverConfiguration;
			var refreshPromise;

			service.refresh = function () {
				var deferred = $q.defer();
				DriverConfiguration.get(function (data) {
					driverConfiguration = data;
					$rootScope.$broadcast('driverConfigUpdated');
					deferred.resolve(data);
				});
				refreshPromise = deferred.promise;
				return refreshPromise;
			};

			service.get = function () {
				if (driverConfiguration) {
					return $q(function (resolve) {
						resolve(driverConfiguration);
					});
				}
				if (refreshPromise) {
					return refreshPromise;
				}
				return service.refresh();
			};

			service.update = function (driverConfiguration) {
				var deferred = $q.defer();
				new DriverConfiguration(driverConfiguration).$update(
					function (data) {
						deferred.resolve(data);
					},
					function (data) {
						deferred.reject(data);
					}
				);
				return deferred.promise;
			};

			service.isClusterModeEnabled = function () {
				return service.get().then(configuration => {
					return (
						configuration.cluster_mode &&
						[CLUSTER_MODE_TYPES.INVENTORY_PICKUP, CLUSTER_MODE_TYPES.INVENTORY_PICKUP_DROPOFF].includes(
							configuration.cluster_mode_type
						)
					);
				});
			};

			$rootScope.$watch(Authentication.isLoggedIn, function () {
				if ($rootScope.isLoggedIn) {
					service.refresh();
				} else {
					driverConfiguration = undefined;
					refreshPromise = undefined;
				}
			});

			return service;
		}
	);
